/* eslint-disable react/jsx-curly-newline */
/* eslint-disable no-nested-ternary */
import React, { useState, useEffect} from "react";
import PropTypes from "prop-types";
import { useSelector } from "react-redux";

// components
import { Grid, Input, Loading } from "@design-system-coopeuch/web";
import SimpleCard from "../../molecules/SimpleCard/SimpleCard";
import Modal from "../../atoms/ShowContent/index";
// utils
import { toCurrencyFormat } from "../../../../domain/utils/utilitarios-frontend-coopeuch/currency";

// styles
import { StyledGridFees, StyledGridText } from "./styles";
import { StyledButton } from "../../../assets/styles/styles";

// assets
import IconInfo2 from "../../../assets/img/icon-persona-cuote.svg";
import Iquals from "../../../assets/img/equals.svg";
/* istanbul ignore next */
const CardParticipationFees = (props) => {
  const {
    monthlyFees,
    monthlyInvestment,
    participationFeesParams,
    isValidMonthlyFee,
    onChange,
    handleChangeCustom,
    abono
  } = props;
  /* istanbul ignore next */
  const {valorAbono} = abono;
  const [openModal, setOpenModal] = useState(false);
  const [hasUserTyped, setHasUserTyped] = useState(false);
  /* istanbul ignore next */
  const documentPdf = useSelector((state) => state.entities.documents);
  /* istanbul ignore next */
  const showModal = () => {
    setOpenModal(true);
    handleChangeCustom("SOLICITUD_HOJA_RESUMEN_CV", "GENERICO", "ENR3.1");
  };
  /* istanbul ignore next */
  const closeModal = () => setOpenModal(false);
  /* istanbul ignore next */
  useEffect(() => {
    if (valorAbono) {
      sessionStorage.setItem('abono', valorAbono);
    }
  }, [valorAbono]);
  /* istanbul ignore next */
  return (
    <SimpleCard
      contentHeader={
        <p className="simplecard__title">¡Prepárate para unirte a Coopeuch!</p>
      }
    >
      <Grid className="m-0 padding-16 p-md-6">
        <Grid className="mb-2 p-0" col={12}>
          <StyledGridText className="flex-container">
            <div className="content">
              <p className="subtitle-cuotas-info">
                Comienza con la elección de tus cuotas de participación
              </p>
              <ul className="section-info-cuotas">
                <li>
                  La cuota de participación es tu aporte a la cooperativa y lo
                  que da derecho a ser socio(a).
                </li>
                <li>
                  Es una inversión mensual que te permitirá ser parte de los
                  beneficios de la cooperativa, entre ellos el remanente.
                </li>
                <li>
                  Tus cuotas serán descontadas de forma automática desde tu
                  Cuenta Vista (PAC).
                </li>
              </ul>
              <p className="activa-tu-cuenta">
                Activa tu Cuenta Vista{" "}
                <button 
                  type="button"
                  className="resume-pdf" 
                  onClick={showModal}
                  style={{ background: 'none', border: 'none', padding: 0, cursor: 'pointer', color: 'inherit', font: 'inherit' }}
                >
                  Ver Hoja Resumen
                </button>
              </p>
              <ul className="section-info-cuotas">
                <li>
                  <strong>Mantención y transacciones costo $0</strong> al
                  abonar tu sueldo, o recibir depósito desde $200.000
                  mensuales.
                </li>
                <li>Si tienes entre 18 y 24 años, tu cuenta es costo $0. </li>
                <li>
                  Se activa con un abono inicial y único de solo $1.000, que
                  quedarán disponibles en tu nueva cuenta.
                </li>
              </ul>
            </div>
          </StyledGridText>
        </Grid>

        <StyledGridFees col={12}>
          <Grid className="image-container">
            <img src={IconInfo2} alt="Descripción de la imagen" />
          </Grid>
          <div className="container-value-cuote">
            <div className="content">
              <p className="text-inversion">
                ¿Cuántas cuotas deseas invertir?
              </p>

              <Input
                value={hasUserTyped ? monthlyFees.value : ""}
                placeholder={"Ej: 10"}
                assistText={[
                  {
                    text: `Mínimo ${participationFeesParams.minMonthlyFee}, máximo ${participationFeesParams.maxMonthlyFee}`,
                    type: isValidMonthlyFee ? "assist" : "error",
                  },
                ]}
                onChange={(value) => {
                  if (!hasUserTyped) setHasUserTyped(true);
                  onChange({
                    field: "monthlyFees",
                    property: "value",
                    value,
                  });
                }}
                onlyNumber
                maxLength={3}
              />
            </div>

            <img
              className="equals"
              src={Iquals}
              alt="Descripción de la imagen"
            />

            <Grid className="d-flex">
              <div className="container-cuote-value">
                <p
                  className={
                    hasUserTyped
                      ? "text-value-cuote"
                      : "text-value-cuote-hide"
                  }
                >
                  <span className="span-value-cuote">
                    Total cuotas mensuales
                  </span>
                  <br />
                  <span className="span-cuote-calc">
                    {hasUserTyped
                      ? toCurrencyFormat(monthlyInvestment.value)
                      : " "}
                  </span>
                </p>
                <p className="white-info-cuote">
                  Es el
                  {' '}<span className="span-info-cuote">
                    valor mensual de tu aporte
                  </span>{' '}
                  como socio(a) de Coopeuch.
                </p>
              </div>
            </Grid>

            <Grid></Grid>
          </div>
        </StyledGridFees>
      </Grid>

      <Modal isOpen={openModal} closeModal={closeModal}>
        <section className="simple-modal-coopeuch-content">
          <article className="simple-modal-coopeuch-header">
            <StyledGridText>
              <h2 className="title-resume">
                Hoja de resumen Apertura de Cuenta Vista
              </h2>
            </StyledGridText>
          </article>
          <article className="simple-modal-coopeuch-body">
            <article className="">
              {documentPdf.successFetching ? (
                <embed
                  src={`data:application/pdf;base64,${documentPdf.pdf}`}
                ></embed>
              ) : (
                <article className="d-flex justify-content-center align-items-center">
                  <Loading />
                </article>
              )}
            </article>
          </article>
          <article className="simple-modal-coopeuch-footer">
            <Grid className="m-0 p-0 py-5 px-4 d-flex justify-content-center align-items-center border-top border-neutral-alfa-15">
              <StyledButton
                disabled={false}
                onClick={closeModal}
                color="secondary"
                variant="default"
              >
                ¡Entendido!
              </StyledButton>
            </Grid>
          </article>
        </section>
      </Modal>
    </SimpleCard>
  );
};

CardParticipationFees.defaultProps = {
  monthlyInvestment: {
    value: 0,
  },
  monthlyFees: {
    value: 0,
  },
  participationFeesParams: {
    value: 0,
    minMonthlyFee: 0,
    maxMonthlyFee: 0,
  },
  authorizationPaymentFirstFee: {
    value: false,
  },
  isValidMonthlyFee: false,
  abono: {
    valorAbono:0
  },
  onChange: () => null,
};

CardParticipationFees.propTypes = {
  monthlyInvestment: PropTypes.shape({
    value: PropTypes.number,
  }),
  monthlyFees: PropTypes.shape({
    value: PropTypes.number,
  }),
  participationFeesParams: PropTypes.shape({
    value: PropTypes.number,
    minMonthlyFee: PropTypes.number,
    maxMonthlyFee: PropTypes.number,
  }),
  authorizationPaymentFirstFee: PropTypes.shape({
    value: PropTypes.bool,
  }),
  abono: PropTypes.shape({
    valorAbono: PropTypes.number
  }),
  isValidMonthlyFee: PropTypes.bool,
  onChange: PropTypes.func,
  handleChangeCustom: PropTypes.func,
};

export default CardParticipationFees;